export default "__VITE_ASSET__CNhaeqfe__"